import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Moment from 'react-moment'
import { ItemList } from '../components'
import { clearNotification } from '../state/notifications/actions'
const FlashMessage = ({ notification, onClose }) => {
  const { title, text, created_at } = notification
  return (
    <div>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">
              <strong> {title} </strong>
              <sub>
                <Moment fromNow>{created_at}</Moment>
              </sub>
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12">
          <p style={{ wordWrap: 'break-word' }} className="text-justify">
            {text}
          </p>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </div>
  )
}

export const FlashList = (props) => {
  const { notifications } = useSelector((state) => state.notifications)
  const dispatch = useDispatch()
  return (
    <ReactBootstrap.Modal show={notifications.length > 0}>
      <ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Title>Flash Alerts</ReactBootstrap.Modal.Title>
      </ReactBootstrap.Modal.Header>
      <ReactBootstrap.Modal.Body>
        <ItemList
          itemRenderer={(index, key) => {
            return (
              <div key={index}>
                <FlashMessage notification={notifications[index]} />
              </div>
            )
          }}
          length={notifications.length}
        />
        <ReactBootstrap.Button
          variant="danger"
          onClick={() => dispatch(clearNotification())}
          className="float-end"
        >
          Clear
        </ReactBootstrap.Button>
      </ReactBootstrap.Modal.Body>
    </ReactBootstrap.Modal>
  )
}
